export class NicheModel {
  guid: string;
  name: string;
  title: string;
}
